import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);


const circle = document.querySelectorAll('#circle') // starting circle shape
const blob = document.querySelectorAll('#blob') // middle blob shape
const midround = document.querySelectorAll('#midround') // middle blob shape
const between = document.querySelectorAll('#between') // middle blob shape
const rounded = document.querySelectorAll('#rounded') // middle blob shape
const hexagon = document.querySelectorAll('#hexagon') // ending hexagon shape
const wrapper = document.querySelectorAll('.js-trigger')
const shape = document.querySelectorAll('.js-shape')

const stepArray = gsap.utils.toArray('.process__step');

// global var for medium screen media query
let mqMed = window.matchMedia("(min-width: 576px)");

let count = stepArray.length;
let halfway = Math.round(count / 2); // no decimals
console.log(count, halfway);

if (mqMed.matches) {
    gsap.timeline({
        scrollTrigger: {
            trigger: wrapper,
            pin: shape,
            start: "top center",
            end: "bottom 80%",
        },
    })

    // update numbers on scroll
    Array.from(stepArray).forEach((step) => {
        const number = document.querySelectorAll('.js-number')
        var currentNum = Math.round(step.dataset.count);
        ScrollTrigger.create({
            trigger: step,
            start: 'top 50%',
            scrub: true,
            onEnter: () => {
                document.querySelector('.js-number').innerHTML = currentNum
            },
            once: false,
        })
    })
    // swap numbers backwards
    Array.from(stepArray).forEach((step) => {
        const number = document.querySelectorAll('.js-number')
        var currentNum = Math.round(step.dataset.count);
        ScrollTrigger.create({
            trigger: step,
            start: 'bottom 50%',
            scrub: true,
            onLeaveBack: () => {
                document.querySelector('.js-number').innerHTML = currentNum
            },
            once: false,
        })
    })

    // add active class to current step
    Array.from(stepArray).forEach((step) => {
        ScrollTrigger.create({
            trigger: step,
            start: 'top 50%',
            scrub: true,
            toggleClass: { targets: step, className: "-active" },
            once: false,
        })
    })

    // set initial fill of SVG shape
    gsap.set(circle, { fill: '#053364' });



    // change SVG shape/color on scroll

    // default is 3 steps
    if (count == 3) {
        gsap.to(circle, {
            morphSVG: blob,
            duration: 1,
            fill: "#2b6889",
            scrollTrigger: {
                trigger: '.js-step1', // always start at first step
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: blob,
        }, {
            morphSVG: hexagon,
            duration: 1,
            immediateRender: false,
            fill: "#db8906",
            scrollTrigger: {
                trigger: '.js-step' + halfway, // morph shape at halfway point
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: hexagon,
        }, {
            morphSVG: hexagon,
            duration: 1,
            immediateRender: false,
            scrollTrigger: {
                trigger: '.js-step' + count, // finish morph on last step
                scrub: true,
                start: "top top",
            }
        }, "+=1")
    }

    // if count is 4 add 1 more shape
    if (count == 4) {
        // change SVG shape/color on scroll
        gsap.to(circle, {
            morphSVG: blob,
            duration: 1,
            fill: "#2b6889",
            scrollTrigger: {
                trigger: '.js-step1',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: blob,
        }, {
            morphSVG: rounded,
            duration: 1,
            immediateRender: false,
            fill: "#fab84c",
            scrollTrigger: {
                trigger: '.js-step2',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: rounded,
        }, {
            morphSVG: hexagon,
            duration: 1,
            immediateRender: false,
            fill: "#db8906",
            scrollTrigger: {
                trigger: '.js-step3',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: hexagon,
        }, {
            morphSVG: hexagon,
            duration: 1,
            immediateRender: false,
            scrollTrigger: {
                trigger: '.js-step4', // finish morph on last step
                scrub: true,
                start: "top top",
            }
        }, "+=1")
    }

    // if count is 6 add 2 more shapes
    if (count == 6) {
        // change SVG shape/color on scroll
        gsap.to(circle, {
            morphSVG: blob,
            duration: 1,
            fill: "#2b6889",
            scrollTrigger: {
                trigger: '.js-step1', // always start at first step
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: blob,
        }, {
            morphSVG: midround,
            duration: 1,
            immediateRender: false,
            fill: "#3c828c",
            scrollTrigger: {
                trigger: '.js-step2',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: midround,
        }, {
            morphSVG: between,
            duration: 1,
            immediateRender: false,
            fill: "#75855b",
            scrollTrigger: {
                trigger: '.js-step3',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: between,
        }, {
            morphSVG: rounded,
            duration: 1,
            immediateRender: false,
            fill: "#fab84c",
            scrollTrigger: {
                trigger: '.js-step4',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: rounded,
        }, {
            morphSVG: hexagon,
            duration: 1,
            immediateRender: false,
            fill: "#db8906",
            scrollTrigger: {
                trigger: '.js-step5',
                scrub: true,
                start: "top top",
            }
        }, "+=1")

        gsap.fromTo(circle, {
            morphSVG: hexagon,
        }, {
            morphSVG: hexagon,
            duration: 1,
            immediateRender: false,
            scrollTrigger: {
                trigger: '.js-step6', // finish morph on last step
                scrub: true,
                start: "top top",
            }
        }, "+=1")
    }
}